// extracted by mini-css-extract-plugin
export var colorBase = "v8qMue9qFgpgpgvZoW0u";
export var colorDisabled = "ZFCsvxoObRtSUrqU_ZJg";
export var colorInverted = "j08ahVjJFS0Zfrd3kLE7";
export var colorNegative = "iJXqvjZGhFbdYvge33sr";
export var colorPositive = "nXDmfZRnIE_97YoWEXRL";
export var colorSubdued = "IY74GRdpssqtzF9vDyFS";
export var colorSubtle = "IjO9w_GgzuhhawyeNNwM";
export var colorUrgencyHigh = "_XpGUnwSswq6u0XNqhUd";
export var colorUrgencyMedium = "glqThc6w5B3BPEp9OSVQ";
export var colorWarning = "ItIIt1LfwOOnOzvLOGWg";
export var colorWhite = "OWrNjMSl4GbdaU2KMH7l";